export * from "./defaultPagesListComponent";
